module.exports = __webpack_public_path__ + "img/CV.Drainage.Drainage_trench.Clay_pipe.c38cea66.png";